import { BsArrowClockwise } from "react-icons/bs";
import { BsChevronDoubleDown } from "react-icons/bs";
import { BsChevronDoubleUp } from "react-icons/bs";
import { BsExclamationTriangleFill } from "react-icons/bs";

import { alpha, Box, Button, Tooltip, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import styles from "./Answer.module.css";
import IconWrapper from "../../Common/IconWrapper";
import { useTranslation } from "react-i18next";

interface Props {
    error: string;
    onRetry: () => void;
    isLast: boolean;
}

export const AnswerError = ({ error, onRetry, isLast }: Props) => {
    const theme = useTheme();
    const { t } = useTranslation("translation", { keyPrefix: "chat" });
    const [showError, setShowError] = useState(false);

    const RefreshIcon = IconWrapper(BsArrowClockwise);
    const ChevronDownIcon = IconWrapper(BsChevronDoubleDown);
    const ChevronUpIcon = IconWrapper(BsChevronDoubleUp);
    const WarningIcon = IconWrapper(BsExclamationTriangleFill);

    return (
        <Box className={styles.answerContainer} sx={{ background: "transparent" }}>
            <Typography
                variant="h6"
                color={theme.palette.text.primary}
                style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    marginBottom: "0.75rem",
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "3%"
                }}
            >
                <Box component="span">
                    <WarningIcon style={{ width: "26px", height: "26px", marginRight: "10px", marginTop: "5px", color: "red" }} />
                </Box>
                {t("answerError.title")}
            </Typography>
            <Box sx={{ marginLeft: "3%", marginTop: 0, display: "flex", flexDirection: "row" }}>
                <Typography color={theme.palette.text.primary} style={{ marginLeft: "3%", marginTop: 0, fontSize: "1rem" }}>
                    {t("answerError.hint")}
                </Typography>
                <Box className={styles.showErrorContainer} onClick={() => setShowError(!showError)}>
                    {showError ? (
                        <Tooltip title={t("answerError.showLess")} placement="top">
                            <ChevronUpIcon style={{ color: theme.palette.primary.light }} className={styles.showErrorButton} />
                        </Tooltip>
                    ) : (
                        <Tooltip title={t("answerError.showMore")} placement="top">
                            <ChevronDownIcon style={{ color: theme.palette.primary.light }} className={styles.showErrorButton} />
                        </Tooltip>
                    )}
                </Box>
            </Box>
            {showError && (
                <Box sx={{ display: "flex", flexDirection: "column", marginLeft: "3%", marginTop: "10px" }}>
                    <Typography color={theme.palette.text.primary} style={{ marginLeft: "3%", fontSize: "1.2rem", fontWeight: 600 }}>
                        {t("answerError.detailsLabel")}
                    </Typography>
                    <Box
                        component="pre"
                        sx={{
                            mt: 1,
                            p: 1.25,
                            borderRadius: 1,
                            overflowX: "auto",
                            bgcolor: theme.palette.mode === "dark" ? alpha(theme.palette.white, 0.06) : alpha(theme.palette.black, 0.04),
                            color: "text.primary"
                        }}
                    >
                        {error}
                    </Box>
                </Box>
            )}

            {isLast && (
                <Box style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
                    <Button variant="contained" className={styles.retryButton} sx={{ backgroundColor: theme.palette.primary.main }} onClick={onRetry}>
                        <Box component="span" sx={{ marginTop: "6px" }}>
                            <RefreshIcon style={{ color: "white" }} className={styles.replayIcon} />
                        </Box>
                        <Typography color={theme.palette.text.secondary} sx={{ marginTop: "6px" }}>
                            {t("answerError.retry")}
                        </Typography>
                    </Button>
                </Box>
            )}
        </Box>
    );
};
